import PerfilesModulos from "../../../pages/admin-usuarios/perfiles-modulos/Main";
import Sistemas from "../../../pages/admin-usuarios/sistemas/Main";
import Modulos from "../../../pages/admin-usuarios/modulos/Main";
import Perfiles from "../../../pages/admin-usuarios/perfiles/Main";
import UsuarioPerfiles from "../../../pages/admin-usuarios/usuarios-perfiles/Main";
import Usuarios from "../../../pages/admin-usuarios/usuarios/Main";
import { FunctionComponent } from "react";

const rutasAdminUsuarios: Array<{ path: string, elemento: FunctionComponent }> = [
    { path: "/modulos", elemento: Modulos },
    { path: "/perfiles", elemento: Perfiles },
    { path: "/perfiles-modulos", elemento: PerfilesModulos },
    { path: "/sistemas", elemento: Sistemas },
    { path: "/usuarios", elemento: Usuarios },
    { path: "/usuarios-perfiles", elemento: UsuarioPerfiles },
]

export default rutasAdminUsuarios;